import { createRouter, createWebHistory } from 'vue-router'
import ruleRoutes from '@/features/rules/routes'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/AppShell.vue'),
    children: [
      {
        path: '',
        redirect: '/rules',
      },
      ...ruleRoutes,
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
